import { render, staticRenderFns } from "./AmendmentDetail.vue?vue&type=template&id=2dc7ae60&"
import script from "./AmendmentDetail.vue?vue&type=script&lang=ts&"
export * from "./AmendmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AmendmentDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports